import React, {Component} from 'react';
import {Table} from 'semantic-ui-react';

class EmptyOrderList extends Component {
  render() {
    return (
      <Table.Row>
        <Table.Cell colSpan='100%' textAlign='center'>
          No existe información para la consulta.
        </Table.Cell>
      </Table.Row>
    );
  }
}

export default EmptyOrderList;
